import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Service } from "utils/services";
import { useTranslation } from "react-i18next";
import { PostReaction } from "models/postReaction";

export default function TextReaction({
  post,
  onOpenReactionDialog,
}: {
  post: any;
  onOpenReactionDialog: (post: any, postReaction: PostReaction) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row items-center justify-between w-full">
      <div className="flex ">
        {post?.like_users && post?.like_users.length > 0 ? (
          <>
            <div className="flex justify-center -space-x-3 rtl:space-x-reverse mr-1 ">
              {post?.like_users.map((likeUser: any, indexFriUser: number) => {
                return (
                  <ImageUrlProfile
                    key={indexFriUser}
                    isLinkProfile={true}
                    user={likeUser}
                    className="w-6 h-6 border-2 border-white rounded-full dark:border-gray-800"
                    alt=""
                  />
                );
              })}
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="flex flex-row">
          {/* Love */}
          {Service.toInteger(post?.reaction_like_count) > 0 && (
            <p
              className="font-normal hover:underline cursor-pointer mr-1"
              onClick={() => onOpenReactionDialog(post, PostReaction.like)}
            >{`${post?.reaction_like_count} ${
              Service.toInteger(post?.reaction_like_count) > 1
                ? t("Loves")
                : t("Love")
            }`}</p>
          )}

          {/* Comment */}
          {/* {Service.toInteger(post?.comment_count) > 0 && (
            <p
              className="font-normal hover:underline cursor-pointer mr-1"
              onClick={() => onOpenReactionDialog(post, PostReaction.comment)}
            >{`${post?.comment_count} ${
              Service.toInteger(post?.comment_count) > 1
                ? t("Comments")
                : t("Comment")
            }`}</p>
          )} */}

          {/* share */}
          {Service.toInteger(post?.reaction_share_count) > 0 && (
            <p
              className="font-normal hover:underline cursor-pointer"
              onClick={() => onOpenReactionDialog(post, PostReaction.share)}
            >{`${post?.reaction_share_count} ${
              Service.toInteger(post?.reaction_share_count) > 1
                ? t("Shares")
                : t("Share")
            }`}</p>
          )}
        </div>

        {/* <p className="font-normal">{`${
          post?.reaction_like_count === 0 || post?.reaction_like_count === "0"
            ? ""
            : post?.reaction_like_count
        } ${
          post?.reaction_like_count === 0 || post?.reaction_like_count === "0"
            ? ""
            : post?.reaction_like_count > 1
            ? "Likes "
            : "Like "
        }${
          post?.comment_count === 0 || post?.comment_count === "0"
            ? ""
            : post?.comment_count
        } ${
          post?.comment_count === 0 || post?.comment_count === "0"
            ? ""
            : post?.comment_count > 1
            ? "Comments "
            : "Comment "
        }   ${
          post?.reaction_share_count === "0" || post?.reaction_share_count === 0
            ? ""
            : post?.reaction_share_count
        } ${
          post?.reaction_share_count === "0" || post?.reaction_share_count === 0
            ? ""
            : post?.reaction_share_count !== "1"
            ? "Shares "
            : "Share "
        }`}</p> */}
      </div>
      {post?.reach_users && post?.reach_users.length > 0 ? (
        <div className="flex justify-end items-end ">
          <div className="flex justify-center -space-x-4 rtl:space-x-reverse mr-1">
            {post?.reach_users.map((viewUser: any, indexFriUser: number) => {
              return (
                <ImageUrlProfile
                  key={indexFriUser}
                  isLinkProfile={true}
                  user={viewUser}
                  className="w-6 h-6 border-2 border-white rounded-full dark:border-gray-800"
                  alt=""
                />
              );
            })}
          </div>
          <p
            className="font-normal hover:underline cursor-pointer"
            onClick={() => onOpenReactionDialog(post, PostReaction.view)}
          >
            {post?.reach_count > 1
              ? `${post?.reach_count} ${t("Views")}`
              : `${post?.reach_count} ${t("View")}`}
          </p>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
